import { themeParams } from '@tma.js/sdk';
import { RGB } from '@tma.js/types';

const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;
const toRgb = (value: string | undefined | null): RGB | undefined => (value && HEX_COLOR_RE.test(value) ? (value as RGB) : undefined);

export interface ThemeColors {
    backgroundColor: RGB | undefined;
    textColor: RGB | undefined;
}

export const getButtonThemeColors = (isEnabled: boolean = true): ThemeColors => {
    if (!isEnabled) {
        return {
            backgroundColor: '#3D3D3D' as RGB,
            textColor: '#9CA3AF' as RGB,
        };
    }

    const backgroundBase = themeParams.buttonColor();
    const textBase = themeParams.buttonTextColor();

    return {
        backgroundColor: toRgb(backgroundBase),
        textColor: toRgb(textBase),
    };
};
